import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row } from 'reactstrap';
import { LoginSideBar, LoginForm } from '../components';
import { loginAccess } from '../actionCreators';
import { checkLoginForm } from '../../formValidator/loginForm';
import '../assets/styles/login.scss';
import { FORM_SUBMIT_LOADER } from '../actions';
class Login extends Component {
  constructor(props){
    super(props);
    this.state = {
      errors: {}
    }
  }
  componentDidMount(){
    this.props.formSubmitLoader(false);
  }
  loginSubmit = (e) => {
    e.preventDefault();
    const validateNewInput = checkLoginForm({email: e.target.email.value, password: e.target.password.value});
    if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === '' })) {
      this.props.formSubmitLoader(true);
      this.props.requestLogin({email: e.target.email.value, password: e.target.password.value});
      this.setState({
        errors: {}
      });
    }else{
      this.setState({
        errors: validateNewInput
      });
    }
  }
  render() {
    const { loginLoader } = this.props;
    return(
      <Row className="flex-not-centered login-wrap">
        <LoginSideBar />
        <LoginForm loginLoader={loginLoader} loginSubmit={this.loginSubmit} errors={this.state.errors} />
      </Row>
    )
  }
}

const mapStateToProps = state => ({
  loginLoader: state.userAssetReducer.loginLoader
});
const mapDispatchToProps = dispatch => {
  return {
    requestLogin: (userInfo) => dispatch(loginAccess(userInfo)),
    formSubmitLoader: (flag) => dispatch({
      type:FORM_SUBMIT_LOADER,
      payload: flag
    }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
